import React from "react";
import { observer, inject } from "mobx-react";
import { observe } from 'mobx';
import {ClipLoader} from "react-spinners";
import HttpClient from "services/HttpClient";
import Pagination from "./Pagination";
import MyOrgWorkshopsCard from "./MyOrgWorkshopsCard";

const GET_MY_REGULAR_WORHSHOPS_URL = "/api/v1/workshops/my/?workshop_type=4";

@inject("user")
@inject("myRegularWorkshops")
@inject("searchFieldEventEmitter")
@observer
export default class MyOrgWorkshopsList extends React.Component {
  state = {
    downloaded: false,
    isLoading: false,
  }

  componentWillMount = () => {
    this.props.searchFieldEventEmitter.setInitialState();
    this.getMyWorkshops('');
    this.subscribeChangePage = observe(this.props.searchFieldEventEmitter, 'page', () => this.changePage());
  };

  redirectToAttendees = provider_id => {
    this.props.history.push(`/provider/my_org_workshops/${provider_id}`);
  };

  getMyWorkshops = (url) => {
    this.setState({isLoading: true});
    new HttpClient().get(GET_MY_REGULAR_WORHSHOPS_URL + url).then(response => {
      const myList = response.body.data.workshops;
      this.props.myRegularWorkshops.setNewList(myList);
      this.setState({
        downloaded: true,
        isLoading: false,
      });
      this.props.searchFieldEventEmitter.setTotalPages(
        response.body.data.pages
      );
    });
  };

  changePage = () => {
    pageTo = `&page=${this.props.searchFieldEventEmitter.page}`;
    this.getMyWorkshops(pageTo)
  }

  componentWillUnmount = () => {
    this.subscribeChangePage();
  }

  showResult = () => {
    return [...this.props.myRegularWorkshops.workshops].map(workshop => (
        <MyOrgWorkshopsCard
          key={workshop.id}
          workshop={workshop}
          redirectToAttendees={this.redirectToAttendees}
        />
      ))
  };

  render() {
    return (
      <main className="main-content purchased">
        <div className="providers-list workshop-list dashboard container-fluid">
          <div className="my-regular-card-list">
            {this.state.downloaded ? this.showResult() : <h1>Loading...</h1>}
            {this.state.isLoading && (
              <div className="spinner-container">
                <ClipLoader color='#00BFFF' loading={this.state.isLoading} size={150} />
              </div>
            )}
          </div>
          <Pagination />
        </div>
      </main>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/providers/MyOrgWorkshops.jsx